// Подсказки в поле ввода бесед-сборщиков (README §10.1 п.3, §10.2 п.3).
// Отдельным модулем: их читает раздел «Беседы» (placeholder CliInput), не таща
// в свой чанк весь сборщик разделов.

export const NEW_HINT = 'например: раздел «Счета» — список оплат из почты, фильтр по месяцу…'
export const EDIT_HINT = 'например: убрать счётчики из бокового меню, добавить фильтр по дате…'
